


















import Vue from 'vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default Vue.extend({
  props: ['value'],
  components: {
    quillEditor,
  },
  data() {
    return {
      content: this.value,
    }
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.html)
    },
  },
})
